import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { BoxModule } from '../common/box/box.module';
import { PlaceloaderModule } from '../common/placeloader/placeloader.module';
import { BoxPlaceloaderComponent } from './box-placeloader.component';

@NgModule({
  imports: [CommonModule, PlaceloaderModule, BoxModule],
  declarations: [BoxPlaceloaderComponent],
  exports: [BoxPlaceloaderComponent],
})
export class RtBoxPlaceholderModule {}
export { BoxPlaceloaderComponent };
